/**
 * Check that the requested routes is one of our configured routes
 *
 * If it isn't, we'll boot them to the Login screen
 */
export const checkRouteValidity = (navItems, pathname) => {
  const routeDetails = {
    location: null,
    isRouteValid: false
  };
  const location = navItems.filter(item => {
    if (!item.path) {
      return true;
    }
    if (item.path === pathname) {
      return true;
    }
    if (item.path.indexOf(":") !== -1) {
      if (item.path.substr(0, item.path.lastIndexOf("/")) === pathname.substr(0, item.path.lastIndexOf("/"))) {
        return true;
      }
    }
    if (item.childRoutes) {
      const validRoute = item.childRoutes.find(childItem => {
        if (childItem.path.indexOf(":") !== -1) {
          if (childItem.path.substr(0, childItem.path.lastIndexOf("/")) === pathname.substr(0, childItem.path.lastIndexOf("/"))) {
            return true;
          }
        }
        return childItem.path === pathname;
      });
      return !!validRoute;
    }
    return false;
  });
  if (location.length > 0) {
    routeDetails.location = location[0];
    routeDetails.isRouteValid = true;
  }
  return routeDetails;
};
export const policyCheck = (navItems, pathname) => {
  var _matchedRoute$allowAc, _matchedRoute;
  let matchedRoute = null;
  navItems.forEach(navItem => {
    if (navItem.path === pathname) {
      matchedRoute = navItem;
    } else if (navItem.childRoutes) {
      navItem.childRoutes.forEach(childItem => {
        if (childItem.path === pathname) {
          matchedRoute = childItem;
        }
      });
    }
  });
  return (_matchedRoute$allowAc = (_matchedRoute = matchedRoute) === null || _matchedRoute === void 0 ? void 0 : _matchedRoute.allowAccess) !== null && _matchedRoute$allowAc !== void 0 ? _matchedRoute$allowAc : true;
};